module.exports = __webpack_public_path__ + "static/media/SF2011_02.75b8a3f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SF2011_02.jpg
// module id = 381
// module chunks = 0